import appName from "@/enums/appName";
import AppEnvEnum from "@/enums/AppEnvEnum";
import statesEnum from "@/enums/statesEnum";
import ConfigService from "@/services/ConfigService";
import { ConfigFactory } from "@/classes/abstractFactory";

const authorizedPages = [statesEnum.LOGIN, statesEnum.SELECT_LESSON_PAGE];
const state = {
  from: {},
  to: {},
  configs: {},
  authorizedPages,
};

const getters = {
  getGoogleAnaliticId: (state) => {
    return state?.configs?.googleAnalitic?.id;
  },
  isProd: (state) => {
    return state?.configs?.env === AppEnvEnum.PROD;
  },
  getAuthorizedPages: (state) => {
    return state.authorizedPages;
  },
  getServerUrl: (state) => {
    return state.configs.serverUrl;
  },
  getDemoClassConfig: (state) => {
    return state.configs.demo.classes;
  },
  getRouteAfterLogin: (state) => {
    switch (state.configs.appName) {
      case appName.TEACHER_APP:
        return statesEnum.TEACHER_ROOM;
      case appName.PARENT_APP:
        return statesEnum.PARENT_ROOM;
      case appName.STUDENT_APP:
        return statesEnum.CALENDAR;
      default:
        return statesEnum.CLASS;
    }
  },
  getRedirectStudentUrl(state, getters) {
    const landingUrl = getters.getRedirectLandingUrl;
    return `${landingUrl}/school/#/calendar`;
  },
  getRedirectTeacherUrl(state, getters) {
    const landingUrl = getters.getRedirectLandingUrl;
    return `${landingUrl}/teacher/#/teacherRoom`;
  },
  getRedirectParentUrl(state, getters) {
    const landingUrl = getters.getRedirectLandingUrl;
    return `${landingUrl}/parent/#/parentRoom`;
  },
  getRedirectLandingUrl(state, getters) {
    const serverUrl = getters.getServerUrl;
    let parsed = serverUrl.split("/");
    parsed.pop();
    const redirectUrl = parsed.join("/");
    return redirectUrl;
  },
  isStudentApp(state) {
    return state.configs.appName === appName.STUDENT_APP;
  },
  isTeacherApp(state) {
    return state.configs.appName === appName.TEACHER_APP;
  },
  isParentApp(state) {
    return state.configs.appName === appName.PARENT_APP;
  },
  getConfigView(state) {
    return state.configs.createConfigView();
  },
  getCurrentState(state) {
    return state.to.name;
  },
  getDemoToken(state) {
    return state.configs.demoToken;
  },
};
const actions = {
  async createConfigs({ commit }, initConfig) {
    const rawConfigs = await ConfigService.createConfigs();
    Object.assign(rawConfigs, initConfig);
    commit("setConfigs", rawConfigs);
  },
  updateRoute({ commit }, payload) {
    const { from, to } = payload;
    commit("setFromRoute", from);
    commit("setToRoute", to);
  },
  removeDemoToken({ commit }) {
    commit("removeToken");
  },
};

const mutations = {
  setConfigs(state, rawConfigs) {
    const builder = ConfigFactory.getConfigBuilder();
    const configs = builder
      .setServerUrl(rawConfigs.serverUrl)
      .setEnv(rawConfigs.env)
      .setGoogleAnalitic(rawConfigs.googleAnalitic)
      .setDemo(rawConfigs.demo)
      .setAppName(rawConfigs.appName)
      .setDemoToken(rawConfigs.demoToken)
      .build();
    state.configs = configs;
  },
  setFromRoute(state, from) {
    state.from = from;
  },
  setToRoute(state, to) {
    state.to = to;
  },
  removeToken(state) {
    state.configs.removeDemoToken();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
